module.exports = __webpack_public_path__ + "img/img_festa1.483390b5.jpg";